import { NgModule } from '@angular/core';
import { DataTestidDirective } from './data-testid.directive';

@NgModule({
  imports: [],
  declarations: [DataTestidDirective],
  exports: [DataTestidDirective],
})
export class DirectiveModule {}
